import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";

function ReceiptModal({
  message,
  isConfirmModal,
  handleConfirmHide,
  onClick,
  buttonLabel,
  buttonprintLabel,
  title,
  row1col1Key,
  row1col1Value,
  row1col2Key,
  row1col2Value,
  row1col3Key,
  row1col3Value,
  row2col1Key,
  row2col1Value,
  row2col2Key,
  row2col2Value,
  row2col3Key,
  row2col3Value,
  row3col1Key,
  row3col1Value,
  row3col2Key,
  row3col2Value,
  row3col3Key,
  row3col3Value,
  row4col1Key,
  row4col1Value,
  row4col2Key,
  row4col2Value,
  row4col3Key,
  row4col3Value,
  row5col1Key,
  row5col1Value,
  row5col2Key,
  row5col2Value,
  row5col3Key,
  row5col3Value,
  row6col1Key,
  row6col1Value,
  row6col2Key,
  row6col2Value,
  row6col3Key,
  row6col3Value,
  row7col1Key,
  row7col1Value,
  row7col2Key,
  row7col2Value,
  row7col3Key,
  row7col3Value,
  row8col1Key,
  row8col1Value,
  row8col2Key,
  row8col2Value,
  row8col3Key,
  row8col3Value,
  row9col1Key,
  row9col1Value,
  row9col2Key,
  row9col2Value,
  row9col3Key,
  row9col3Value,
  row10col1Key,
  row10col1Value,
  row10col2Key,
  row10col2Value,
  row10col3Key,
  row10col3Value,
}) {
  return (
    <>
      <Modal
        show={isConfirmModal}
        onHide={handleConfirmHide}
        // dialogClassName="modal-90w"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        size="xl"
        closeButton
      >
        <Modal.Header closeButton>
          <Modal.Title> {title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center pb-0">
          <div className="row">
            {row1col1Key && (
              <div className="col-md-4 mb-4">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {row1col1Key}
                </h5>
                <p className="text-dark fs-14 font-weight-bold text-left">
                  {row1col1Value ? row1col1Value : "-"}
                </p>
              </div>
            )}
            {row1col2Key && (
              <div className="col-md-4 mb-4">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {row1col2Key}
                </h5>
                <p className="text-dark fs-14 font-weight-bold text-left">
                  {row1col2Value ? row1col2Value : "-"}
                </p>
              </div>
            )}
            {row1col3Key && (
              <div className="col-md-4 mb-4">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {row1col3Key}
                </h5>
                <p className="text-dark fs-14 font-weight-bold text-left">
                  {row1col3Value ? row1col3Value : "-"}
                </p>
              </div>
            )}
            {row2col1Key && (
              <div className="col-md-4 mb-4">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {row2col1Key}
                </h5>
                <p className="text-dark fs-14 font-weight-bold text-left">
                  {row2col1Value ? row2col1Value : "-"}
                </p>
              </div>
            )}
            {row2col2Key && (
              <div className="col-md-4 mb-4">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {row2col2Key}
                </h5>
                <p className="text-dark fs-14 font-weight-bold text-left">
                  {row2col2Value ? row2col2Value : "-"}
                </p>
              </div>
            )}
            {row2col3Key && (
              <div className="col-md-4 mb-4">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {row2col3Key}
                </h5>
                <p className="text-dark fs-14 font-weight-bold text-left">
                  {row2col3Value ? row2col3Value : "-"}
                </p>
              </div>
            )}
            {row3col1Key && (
              <div className="col-md-4 mb-4">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {row3col1Key}
                </h5>
                <p className="text-dark fs-14 font-weight-bold text-left">
                  {row3col1Value ? row3col1Value : "-"}
                </p>
              </div>
            )}
            {row3col2Key && (
              <div className="col-md-4 mb-4">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {row3col2Key}
                </h5>
                <p className="text-dark fs-14 font-weight-bold text-left">
                  {row3col2Value ? row3col2Value : "-"}
                </p>
              </div>
            )}
            {row3col3Key && (
              <div className="col-md-4 mb-4">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {row3col3Key}
                </h5>
                <p className="text-dark fs-14 font-weight-bold text-left">
                  {row3col3Value ? row3col3Value : "-"}
                </p>
              </div>
            )}
            {row4col1Key && (
              <div className="col-md-4 mb-4">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {row4col1Key}
                </h5>
                <p className="text-dark fs-14 font-weight-bold text-left">
                  {row4col1Value ? row4col1Value : "-"}
                </p>
              </div>
            )}
            {row4col2Key && (
              <div className="col-md-4 mb-4">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {row4col2Key}
                </h5>
                <p className="text-dark fs-14 font-weight-bold text-left">
                  {row4col2Value ? row4col2Value : "-"}
                </p>
              </div>
            )}
            {row4col3Key && (
              <div className="col-md-4 mb-4">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {row4col3Key}
                </h5>
                <p className="text-dark fs-14 font-weight-bold text-left">
                  {row4col3Value ? row4col3Value : "-"}
                </p>
              </div>
            )}
            {row5col1Key && (
              <div className="col-md-4 mb-4">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {row5col1Key}
                </h5>
                <p className="text-dark fs-14 font-weight-bold text-left">
                  {row5col1Value ? row5col1Value : "-"}
                </p>
              </div>
            )}
            {row5col2Key && (
              <div className="col-md-4 mb-4">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {row5col2Key}
                </h5>
                <p className="text-dark fs-14 font-weight-bold text-left">
                  {row5col2Value ? row5col2Value : "-"}
                </p>
              </div>
            )}
            {row5col3Key && (
              <div className="col-md-4 mb-4">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {row5col3Key}
                </h5>
                <p className="text-dark fs-14 font-weight-bold text-left">
                  {row5col3Value ? row5col3Value : "-"}
                </p>
              </div>
            )}
            {row6col1Key && (
              <div className="col-md-4 mb-4">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {row6col1Key}
                </h5>
                <p className="text-dark fs-14 font-weight-bold text-left">
                  {row6col1Value ? row6col1Value : "-"}
                </p>
              </div>
            )}
            {row6col2Key && (
              <div className="col-md-4 mb-4">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {row6col2Key}
                </h5>
                <p className="text-dark fs-14 font-weight-bold text-left">
                  {row6col2Value ? row6col2Value : "-"}
                </p>
              </div>
            )}
            {row6col3Key && (
              <div className="col-md-4 mb-4">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {row6col3Key}
                </h5>
                <p className="text-dark fs-14 font-weight-bold text-left">
                  {row6col3Value ? row6col3Value : "-"}
                </p>
              </div>
            )}
            {row7col1Key && (
              <div className="col-md-4 mb-4">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {row7col1Key}
                </h5>
                <p className="text-dark fs-14 font-weight-bold text-left">
                  {row7col1Value ? row7col1Value : "-"}
                </p>
              </div>
            )}
            {row7col2Key && (
              <div className="col-md-4 mb-4">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {row7col2Key}
                </h5>
                <p className="text-dark fs-14 font-weight-bold text-left">
                  {row7col2Value ? row7col2Value : "-"}
                </p>
              </div>
            )}
            {row7col3Key && (
              <div className="col-md-4 mb-4">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {row7col3Key}
                </h5>
                <p className="text-dark fs-14 font-weight-bold text-left">
                  {row7col3Value ? row7col3Value : "-"}
                </p>
              </div>
            )}
            {row8col1Key && (
              <div className="col-md-4 mb-4">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {row8col1Key}
                </h5>
                <p className="text-dark fs-14 font-weight-bold text-left">
                  {row8col1Value ? row8col1Value : "-"}
                </p>
              </div>
            )}
            {row8col2Key && (
              <div className="col-md-4 mb-4">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {row8col2Key}
                </h5>
                <p className="text-dark fs-14 font-weight-bold text-left">
                  {row8col2Value ? row8col2Value : "-"}
                </p>
              </div>
            )}
            {row8col3Key && (
              <div className="col-md-4 mb-4">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {row8col3Key}
                </h5>
                <p className="text-dark fs-14 font-weight-bold text-left">
                  {row8col3Value ? row8col3Value : "-"}
                </p>
              </div>
            )}
            {row9col1Key && (
              <div className="col-md-4 mb-4">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {row9col1Key}
                </h5>
                <p className="text-dark fs-14 font-weight-bold text-left">
                  {row9col1Value ? row9col1Value : "-"}
                </p>
              </div>
            )}
            {row9col2Key && (
              <div className="col-md-4 mb-4">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {row9col2Key}
                </h5>
                <p className="text-dark fs-14 font-weight-bold text-left">
                  {row9col2Value ? row9col2Value : "-"}
                </p>
              </div>
            )}
            {row9col3Key && (
              <div className="col-md-4 mb-4">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {row9col3Key}
                </h5>
                <p className="text-dark fs-14 font-weight-bold text-left">
                  {row9col3Value ? row9col3Value : "-"}
                </p>
              </div>
            )}
            {row10col1Key && (
              <div className="col-md-4 mb-4">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {row10col1Key}
                </h5>
                <p className="text-dark fs-14 font-weight-bold text-left">
                  {row10col1Value ? row10col1Value : "-"}
                </p>
              </div>
            )}
            {row10col2Key && (
              <div className="col-md-4 mb-4">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {row10col2Key}
                </h5>
                <p className="text-dark fs-14 font-weight-bold text-left">
                  {row10col2Value ? row10col2Value : "-"}
                </p>
              </div>
            )}
            {row10col3Key && (
              <div className="col-md-4 mb-4">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {row10col3Key}
                </h5>
                <p className="text-dark fs-14 font-weight-bold text-left">
                  {row10col3Value ? row10col3Value : "-"}
                </p>
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default ReceiptModal;
